export enum DonationGuideVersion {
  V1 = 'V1',
  V2 = 'V2',
}
